module.exports = __webpack_public_path__ + "img/nose.73ad0818.svg";